import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Row,
  Col,
  PageHeader,
  Avatar,
  Divider,
  List,
  Select,
  Modal,
  message,
  Popconfirm,
  Typography,
  Space,
  Layout,
  Alert,
  Card,
  Switch,
} from 'antd';
import {
  updateWorkspace,
  makeWorkspaceAdmin,
  deleteWorkspaceAdmin,
  getWorkspaceAdmins,
} from '../skills/skills_action.js';
import SelectMembers from '../common/memberSelect.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { setUser } from '../common/common_action';
import SyncUserModal from './SyncUserModal';
const { Text } = Typography;
const { Option } = Select;
const { Content } = Layout;

const { confirm } = Modal;

class Admin extends Component {
  constructor(props) {
    super();
    this.state = {
      adminList: [],
      memberList: [],
      isMembersModalVisible: false,
      currentMemberSelected: '',
      isCurrentAdmin: false,
      isChannelConfigurationRestricted: false,
    };
  }

  async componentDidMount() {
    this.props.getWorkspaceAdmins(this.props.workspace._id);

    this.setState({
      isChannelConfigurationRestricted:
        this.props.workspace &&
        this.props.workspace.isChannelConfigurationRestricted,
    });

    // console.log(this.props.user_name);
    // axios
    //   .get(`/api/${this.props.workspace._id}/admins`)
    //   .then((res) => {
    //     if (res.data.success && res.data.admins) {
    //       this.setState({ adminList: res.data.admins });
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("error fetching admins of this workspace from server: ", err);
    //   });
    // axios
    //   .get(`/api/${this.props.workspace._id}/members`)
    //   .then((res) => {
    //     if (res.data.success && res.data.members) {
    //       this.setState({ memberList: res.data.members });
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("error fetching members of this workspace from server: ", err);
    //   });
  }

  showMembersModal = () => {
    this.setState({
      isMembersModalVisible: true,
    });
  };

  handleCancel = () => {
    this.setState({
      isMembersModalVisible: false,
    });
  };

  handleOk = () => {
    this.setState({
      isMembersModalVisible: false,
    });
  };

  makeChannelConfigurationRestricted = (value) => {
    this.props
      .updateWorkspace(this.props.workspace._id, '', {
        isChannelConfigurationRestricted: value,
      })
      .then((res) => {
        this.setState({
          isChannelConfigurationRestricted:
            res.data.workspace.isChannelConfigurationRestricted,
          // isChannelConfigurationRestricted: value,
        });
      });
  };

  addAdmin = (memberId) => {
    this.props
      .makeWorkspaceAdmin(this.props.workspace._id, memberId)
      .then((res) => {
        if (res.data.success) {
          message.success('Admin Added Successfully');
        } else if (res.data.errors && res.data.errors.action == 'change_plan') {
          let t = res.data.errors.text;
          let c = (
            <>
              {' '}
              <p>Upgrade to unlock more Multi-admin access. </p>
              <br />{' '}
            </>
          );
          confirm({
            title: t,
            okText: 'Upgrade',
            icon: <ExclamationCircleOutlined />,
            content: c,
            onOk: () => {
              this.props.history.push(
                '/' + this.props.match.params.wId + '/settings?view=upgrade'
              );

              // this.addAdmin(opt.key)
              //   this.setState({ currentMemberSelected: "" })
            },
            onCancel() {
              //do nothing
              // console.log('Cancel');
            },
          });
        }
      })
      .catch((err) => {
        // console.error('error in adding member as the workspace admin: ', err);
      });
  };

  onMemberSelect = (val, opt) => {
    //  console.log("insiude onMemberSelect",opt);
    // console.log("val -> ",val);
    // console.log("opt -> ",opt.key);

    let t = `This action will add ${opt.children} as administrator of ${this.props.workspace.name}. Are you sure?`;
    let c =
      'Troopr workspace administrators can manage Check-ins, Jira integration, Squads and Workspace features including Billing information.';
    confirm({
      title: t,
      icon: <ExclamationCircleOutlined />,
      content: c,
      onOk: () => {
        this.addAdmin(val);
        this.setState({ currentMemberSelected: '' });
      },
      onCancel() {
        //do nothing
        // console.log('Cancel');
      },
    });
  };

  adminDeletePopconfirmTitle = (name) => {
    return `This action will remove admin privileges for ${name}. Are you sure?`;
  };

  //val is the user id
  deleteAdmin = (val) => {
    let currentUserId = localStorage.getItem('trooprUserId');

    if (currentUserId === val) {
      message.error('Cannot remove yourself from admin list');
      return;
    }

    this.props
      .deleteWorkspaceAdmin(this.props.workspace._id, val)
      .then((res) => {
        if (res.data.success) {
          message.success('Admin converted to member successfully');
        } else if (res.data.errors && res.data.errors.action == 'change_plan') {
          let t = res.data.errors.text;
          let c = (
            <>
              {' '}
              <p>Upgrade to unlock more Multi-admin access. </p>
              <br />{' '}
            </>
          );
          confirm({
            title: t,
            okText: 'Upgrade',
            icon: <ExclamationCircleOutlined />,
            content: c,
            onOk: () => {
              this.props.history.push(
                '/' + this.props.match.params.wId + '/settings?view=upgrade'
              );

              // this.addAdmin(opt.key)
              //   this.setState({ currentMemberSelected: "" })
            },
            onCancel() {
              //do nothing
              // console.log('Cancel');
            },
          });
        } else {
          // console.log("Could not remove the admin role");
        }
      })
      .catch((err) => {
        // console.log("error in removing admin role: ", err);
      });
  };

  // isSelf = (val) => {

  // }

  getInitials(string) {
    if (string) {
      let nameArr = string
        .trim()
        .replace(/\s+/g, ' ') //remove extra spaces
        .split(' ');

      if (nameArr.length > 1)
        return (nameArr[0][0] + nameArr[1][0]).toUpperCase();
      else return nameArr[0].slice(0, 2).toUpperCase();
    } else return '';
  }

  render() {
    let workspaceMembers = [];
    let admins = this.props.admins;
    //     this.props.members.forEach((member) => {
    //       if (member.role == 'admin') {
    //       //  {
    //           /* <Option key={member._id} value={member.name}>
    // {member.name}
    // </Option> */
    //       //  }
    //        // admins.push(member);
    //       } else {
    //         let option = (
    //           <Option
    //             key={member.user_id._id}
    //             value={member.user_id.displayName || member.user_id.name}
    //           >
    //             {member.user_id.displayName || member.user_id.name}
    //           </Option>
    //         );

    //         workspaceMembers.push(option);
    //       }
    //     });

    // let pageHeaderTitle = `${this.props.workspace.name} Administrators: ${this.state.adminList.length}`;
    let pageHeaderTitle = `Administrators (${admins.length})`;

    let adminListDataSource = admins;
    adminListDataSource.sort(function (a, b) {
      let nameA = (a.user_id.displayName || a.user_id.name).toUpperCase(); // ignore upper and lowercase
      let nameB = (b.user_id.displayName || b.user_id.name).toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
    return (
      <>
        <PageHeader title={pageHeaderTitle} />
        <Content
          style={{
            padding: '16px 32px 32px 32px',
            height: '80vh',
            overflow: 'scroll',
          }}
        >
          <Alert
            message='Troopr workspace administrators can manage all Troopr products and also manage Billing information'
            type='info'
            showIcon
            style={{ marginBottom: 8 }}
          />
          <Row gutter={[16, 16, 16]}>
            {this.props.isAdmin && (
              <Col style={{ marginTop: 20 }} span={24}>
                <Card
                  title='Channel configuration restriction'
                  style={{ width: '100%' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Text type='secondary'>
                      Allow only Troopr workspace administrators to configure
                      new Slack channels. For existing channel configurations,
                      corresponding channel administrator(s) in Troopr will have
                      access to update them
                    </Text>
                    <Switch
                      checked={this.state.isChannelConfigurationRestricted}
                      onChange={(value) =>
                        this.makeChannelConfigurationRestricted(value)
                      }
                    ></Switch>
                  </div>
                </Card>
              </Col>
            )}
            {this.props.isAdmin && (
              <Col span={24}>
                <Card title='Add New Administrator' style={{ width: '100%' }}>
                  <Text type='secondary'>
                    Select a workspace member below to add them as workspace
                    Administrator
                  </Text>
                  <br />
                  <br />

                  <SelectMembers
                    wId={this.props.match.params.wId}
                    type={'member'}
                    style={{ width: 200 }}
                    allowClear={true}
                    // defaultValue=""
                    placeholder='Type member name'
                    dropdownClassName='sidebar_dropdown'
                    // value={this.state.memberList._id && this.state.memberList.name}
                    value={this.state.currentMemberSelected}
                    onSelect={this.onMemberSelect}
                    // onChange={this.onMemberChange}
                  />

                  <br />
                  <SyncUserModal />
                </Card>
              </Col>
            )}

            <Col span={24}>
              <Card title='Current Administrators' style={{ width: '100%' }}>
                <List
                  size='small'
                  pagination={{ pageSize: 10 }}
                  itemLayout='horizontal'
                  // loading={true}
                  dataSource={adminListDataSource}
                  renderItem={(item) => (
                    <List.Item
                      actions={[
                        this.props.isAdmin && (
                          <Popconfirm
                            title={() =>
                              this.adminDeletePopconfirmTitle(
                                item.user_id.displayName || item.user_id.name
                              )
                            }
                            onConfirm={() => this.deleteAdmin(item.user_id._id)}
                            // onCancel={cancel}
                            okText='Yes'
                            cancelText='No'
                          >
                            {/* <DeleteOutlined/> */}
                            <a href='#'>Remove Admin</a>
                          </Popconfirm>
                        ),
                      ]}
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar src={item.profilePicUrl}>
                            {this.getInitials(
                              item.user_id.displayName || item.user_id.name
                            )}
                          </Avatar>
                        }
                        title={item.user_id.displayName || item.user_id.name}
                        description={item.email}
                      />
                    </List.Item>
                  )}
                />
              </Card>
              {/* {this.props.isAdmin && ( */}

              {/* )} */}
            </Col>
          </Row>
        </Content>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workspace_name: state.common_reducer.workspace.name,
    workspace: state.common_reducer.workspace,
    user_name: state.common_reducer.user.name,

    admins: state.skills.wAdmins,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    makeWorkspaceAdmin,
    deleteWorkspaceAdmin,
    getWorkspaceAdmins,
    updateWorkspace,
    setUser,
  })(Admin)
);
